import {Directive, Input} from '@angular/core';
import {FormControl} from '@angular/forms';

/**
 * Directive used to set the state as enable/disable for form control.
 */
@Directive({
  selector: '[disableControl]'
})
export class DisableControlDirective {
  private _disableControl: FormControl;
  private _disableControlValue: boolean;

  /**
   * Set Form control as an input
   * @param {FormControl} control
   */
  @Input() set disableControl( control : FormControl ) {
    this._disableControl = control;
    this.setDisable();
  }

  /**
   * Set state of the form control as disable/enable
   * @param {boolean} value
   */
  @Input() set disableControlValue(value: boolean) {
    this._disableControlValue = value;
    this.setDisable();
  }

  private setDisable() {
    if (this._disableControl && this._disableControlValue) {
      this._disableControl.disable();
    }
  }
}
